import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@app/state";
import {
  selectUserTreeList,
  selectCurrentUserTreeList,
} from "@app/state/units";
import { JGAPCommonTree } from "@app/components/treeListCommon";
// import {  } from "@app/state";
import type { TUserTreeListItem } from "@app/types";

export const UserListIco = ({ e }: { e: any }) => {
  const { data }: { data: TUserTreeListItem } = e;
  switch (true) {
    case data.ptlCfgPage === "command":
      return <i className={`dx-icon dx-icon-user`} />;
    case data.ptlCfgPage === "user":
      return <i className={`dx-icon dx-icon-user`} />;
    default:
      return <i className={`dx-icon dx-icon-user`} />;
  }
};

export const UserListTitle = ({ e }: { e: any }) => {
  const { t } = useTranslation();

  return <span>{t(e.data?.ptlTitle || "<title>")}</span>;
};
